"use strict";

class DeveloperInterestRatesController {

    constructor($scope, $window, SSHttpService, SSConfigService, SSAlertService, SSUtilService, OTPService, SSAppService, SSUserService, SSConfirmationService, SSDateService, SSAnalyticsService) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;

        self.SSHttpService = SSHttpService;
        self.SSConfigService = SSConfigService;
        self.SSAlertService = SSAlertService;
        self.SSUtilService = SSUtilService;
        self.OTPService = OTPService;
        self.SSAppService = SSAppService;
        self.SSUserService = SSUserService;
        self.SSDateService = SSDateService;
        self.SSConfirmationService = SSConfirmationService;
        self.SSAnalyticsService = SSAnalyticsService;

        self.PAYMENT_PLAN_TYPE_NPS = SHOWSUITE.PAYMENT_PLAN_TYPE_NPS;
        self.PAYMENT_PLAN_TYPE_DPS = SHOWSUITE.PAYMENT_PLAN_TYPE_DPS;
        self.PAYMENT_PLAN_TYPE_PVT = SHOWSUITE.PAYMENT_PLAN_TYPE_PVT;

        self.PAYMENT_TRIGGER_TYPE_BOOKING = SHOWSUITE.PAYMENT_TRIGGER_TYPE_BOOKING;
        self.PAYMENT_TRIGGER_TYPE_SPA_RECEIVED = SHOWSUITE.PAYMENT_TRIGGER_TYPE_SPA_RECEIVED;

        self.DAYS_CALCULATION_TYPE_CALENDAR_DAYS = SHOWSUITE.DAYS_CALCULATION_TYPE_CALENDAR_DAYS;
        self.DAYS_CALCULATION_TYPE_WORKING_DAYS = SHOWSUITE.DAYS_CALCULATION_TYPE_WORKING_DAYS;

        self.PAYMENT_TYPE_00_STANDARD = SHOWSUITE.PAYMENT_TYPE_00_STANDARD;
        self.PAYMENT_TYPE_01_BOOKING_FEE = SHOWSUITE.PAYMENT_TYPE_01_BOOKING_FEE;
        self.PAYMENT_TYPE_02_DEPOSIT = SHOWSUITE.PAYMENT_TYPE_02_DEPOSIT;
        self.PAYMENT_TYPE_03_FOUNDATION = SHOWSUITE.PAYMENT_TYPE_03_FOUNDATION;
        self.PAYMENT_TYPE_04_CONCRETE_FRAMEWORK = SHOWSUITE.PAYMENT_TYPE_04_CONCRETE_FRAMEWORK;
        self.PAYMENT_TYPE_05_BRICK_WALLS = SHOWSUITE.PAYMENT_TYPE_05_BRICK_WALLS;
        self.PAYMENT_TYPE_06_CEILING = SHOWSUITE.PAYMENT_TYPE_06_CEILING;
        self.PAYMENT_TYPE_07_INTERNAL_WORKS_1 = SHOWSUITE.PAYMENT_TYPE_07_INTERNAL_WORKS_1;
        self.PAYMENT_TYPE_08_INTERNAL_WORKS_2 = SHOWSUITE.PAYMENT_TYPE_08_INTERNAL_WORKS_2;
        self.PAYMENT_TYPE_09_EXTERNAL_WORKS = SHOWSUITE.PAYMENT_TYPE_09_EXTERNAL_WORKS;
        self.PAYMENT_TYPE_10_NOTICE_OF_VACANT_POSSESSION = SHOWSUITE.PAYMENT_TYPE_10_NOTICE_OF_VACANT_POSSESSION;
        self.PAYMENT_TYPE_11_CSC = SHOWSUITE.PAYMENT_TYPE_11_CSC;
        self.PAYMENT_TYPE_13_COMPLETION = SHOWSUITE.PAYMENT_TYPE_13_COMPLETION;
        self.PAYMENT_TYPE_20_REFUND = SHOWSUITE.PAYMENT_TYPE_20_REFUND;

        self.data = SHOWSUITE.data;

        self.has_access = false;
        if (self.SSUserService.isDeveloper()) {
            self.init();
            self.has_access = true;
        }

    }

    init() {
        const self = this;

        self.user = self.SSUserService.getUser();
        if (!self.user) {
          self.SSUserService.showLoginModal();
        }

        // Trigger View Event for Interests Page
        self.SSAnalyticsService.saveAnalyticEvent({
                event: self.SSAnalyticsService.ANALYTICS_EVENT_VIEWS_DMS_INTEREST,
                user_id: self.SSUtilService.getFromLocalStorage('user').id
            }
        );

        self.offset = 0;
        self.limit = 10;
        self.paymentPlans = [];

        // self.pageChanged = function(newPage) {
        //     self.loadInterestRate(newPage);
        // };

        self.preparePaymentPlanTypes();
        self.prepareWeakDays();
        self.setPageOptions();

        self.current = 1;
        self.jump_to_page = 1;

        self.getPaymentPlans();
        self.getInterestRates();
        //
        // $('#interestStartDate').datepicker({dateFormat: 'dd/mm/yy'});
        // $('#interestEndDate').datepicker({dateFormat: 'dd/mm/yy'});
        // self.$timeout(function () {
        //     jQuery('.datepicker').datepicker({
        //         changeMonth: true,
        //         changeYear: true,
        //         dateFormat: "dd/mm/yy"
        //     });
        // });
    }

    getInterestRates(){
        const self = this;

        let url = 'sec/developer/interest-rates';
        let params = {
            include: 'payment_plans_clauses'
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.interest_rates){
                self.interest_rates = response.data.interest_rates;
                self.interest_rates.forEach(function (interestRate) {
                    interestRate.availability_start_date = self.SSUtilService.formatUtcToLocalDateTime(interestRate.availability_start_date);
                    interestRate.availability_end_date = self.SSUtilService.formatUtcToLocalDateTime(interestRate.availability_end_date);
                });
                self.interest_rates_master = angular.copy(self.interest_rates);
                // self.loadInterestRate(undefined, self.interest_rates_master);
            }
        });
    }

    getPaymentPlans(){
        const self = this;

        let url = 'sec/developer/payment-plans/';
        let params = {
            include: 'payment_plan_clauses'
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.payment_plans){
                self.paymentPlans = response.data.payment_plans;
                // $.each(self.interest_rates, function(index, interest){
                //     interest["payment_plans"] = self.getInterestPaymentPlans(interest);
                // });
            }
        });
    }

    getInterestPaymentPlans(interest){
        const self = this;

        var payment_plans = [];

        $.each(interest.payment_plan_clauses, function(index, clause){
            let payment_plan = self.paymentPlans.find(x => x.id == clause.payment_plan_id);
            // Check if payment plan already pushed to 'interest'
            if(!payment_plans.find(x => x.id == payment_plan.id)){
                payment_plans.push(payment_plan);
            }
        });

        return payment_plans;
    }

    // CLIENT SIDE PAGINATION
    // loadInterestRate(page, interest_rates){
    //     const self = this;

    //     if(page) {
    //         self.offset = (page * self.limit) - self.limit;
    //         self.current = page;
    //         self.jump_to_page = page;
    //     }

    //     if(!payment_plans){
    //         payment_plans = self.payment_plans_backup;
    //     }

    //     self.payment_plans_master = payment_plans.slice(self.offset, self.limit + self.offset);
    //     self.count = payment_plans.length;

    //     // SET 'CURRENT SELECTED UNITS' COUNT
    //     if(parseInt(self.limit) < parseInt(self.payment_plans_master.length)){
    //         self.selected_payment_plans_count = self.limit;
    //     }
    //     else{
    //         self.selected_payment_plans_count = self.payment_plans_master.length;
    //     }

    //     // SET TOTAL PAGES ARRAY FOR 'JUMP TO' FEATURE
    //     let total_pages = Math.ceil(self.count / self.limit);
    //     self.setTotalPagesOptions(total_pages);
    // }

    setInterestRateUpdateMode(interest){
        const self = this;

        self.interestPaymentPlans = {};

        self.interestRateParams = {};
        self.interestRateErrors = {};

        self.interestRateParams.cumulativeInterestRate = 0;

        self.working_days = [];
        for(var index = 1; index <= 7; index++){
            self.working_days[index] = false;
        }

        if(interest){
            self.interestRateParams = angular.copy(interest);
            self.is_enabled = self.interestRateParams.is_enabled? true: false;
            self.observe_public_holidays = self.interestRateParams.observe_public_holidays? true: false;
            self.skip_only_if_due_on_off_day = self.interestRateParams.skip_only_if_due_on_off_day? true: false;
            self.calculateInterestRate();
            if(self.interestRateParams.working_days){
                var ids = self.interestRateParams.working_days.split(',');
                $.each(ids, function(i, id){
                    self.working_days[id] = true;
                });
            }
            self.editInterestRate = false;

            self.interestPaymentPlans = self.getInterestPaymentPlans(interest);
        }
        else{
            self.editInterestRate = true;
        }

        self.interestRateUpdateMode = true;

        // self.$timeout(function () {
        //     jQuery('.datepicker').datetimepicker({
        //         dateFormat: "dd/mm/yy",
        //         changeMonth: true,
        //         changeYear: true,
        //         showTimePicker: false,
        //         showSecond:false,
        //         showMillisec:false,
        //         showMicrosec:false,
        //         showTimezone:false
        //     });
        // });
    }

    updateInterestRate(){
        const self = this;

        self.interestRateErrors = {};
        
        var working_days = '';
        $.each(self.working_days, function(key, value){
            if(value == true){
                working_days += key.toString() + ",";
            }
        });
        self.interestRateParams.working_days = working_days.substring(0, working_days.lastIndexOf(','));

        // Validate input fields
        if(!self.isValidInterestRateInput()){
            return;
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to ' + (self.interestRateParams.id ? 'update' : 'create') + ' this interest rate?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {

                let url = 'sec/developer/interest-rates';

                let params = self.interestRateParams;
                params.observe_public_holidays = self.observe_public_holidays ? 1 : 0;
                params.skip_only_if_due_on_off_day = self.skip_only_if_due_on_off_day ? 1 : 0;
                params.is_enabled = self.is_enabled ? 1 : 0;
                params.grace_period = params.grace_period ? params.grace_period : 0;
                params.availability_start_date = self.SSUtilService.formatLocalToUtc(params.availability_start_date);
                params.availability_end_date = self.SSUtilService.formatLocalToUtc(params.availability_end_date);

                let responseHandler = function(response){
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);

                        if (response && response.code == 403) {
                            self.SSAlertService.danger('Forbidden!', 'The selected payment plan clause has already and active interest rate.');
                        }
                        return;
                    }

                    self.SSAlertService.success('Success!', 'Interest rate updated successfully.');
                    self.getInterestRates();
                    self.interestRateUpdateMode = false;
                };

                loading(true);
                if(self.interestRateParams.id){
                    url += '/' + self.interestRateParams.id;
                    self.SSHttpService.putAPIRequest(url, params).then(responseHandler);
                }
                else{
                    self.SSHttpService.postAPIRequest(url, params).then(responseHandler);
                }
            }
        );
    }

    setPaymentPlanEditMode(payment_plan){
        const self = this;

        self.paymentPlanParams = {};
        self.paymentPlanErrors = {};
        self.selected_payment_plan_clauses = [];
        self.selected_all_payment_plan_clauses = false;

        if(payment_plan){
            self.paymentPlanParams = angular.copy(payment_plan);

            let _payment_plan = self.paymentPlans.find(x => x.id == payment_plan.id);

            if(_payment_plan){

                var addedClauses = self.interestRateParams.payment_plan_clauses;
                self.paymentPlanParams.clauses = _payment_plan.payment_plan_clauses;

                $.each(_payment_plan.payment_plan_clauses, function(index, clause){

                    let addedPaymentPlanClause = addedClauses ? addedClauses.find(x => x.payment_plan_clause_id == clause.id) : null;
                    if(addedPaymentPlanClause && addedPaymentPlanClause.payment_plan_id == _payment_plan.id){
                        self.selected_payment_plan_clauses[clause.id] = true;
                    }
                    else{
                        self.selected_payment_plan_clauses[clause.id] = false;
                    }
                });
                self.checkAllPaymentPlanClausesSelected();
            }
            self.PAYMENT_PLAN_SELECTED = true;
        }
        else{
            self.PAYMENT_PLAN_SELECTED = false;
            self.paymentPlanParams.clauses = [];
        }

        $('#addPaymentPlanModal').modal('show');
    }

    updatePaymentPlan(){
        const self = this;

        self.paymentPlanErrors = {};
        
        var payment_plans_with_clauses = '';

        try{
            // Prepare data for params
            $.each(self.selected_payment_plan_clauses, function(key, value){
                if(value == true){
                    payment_plans_with_clauses += '{"payment_plan_id":'+ self.paymentPlanParams.id +', "payment_plan_clause_id":'+ key +'},';
                }
            });

            if(!payment_plans_with_clauses){
                self.paymentPlanErrors.clauses = "Please select payment plan clauses";
                return;
            } 

            var existing_clauses = [];
            if(self.interestRateParams.payment_plan_clauses){
                $.each(self.interestRateParams.payment_plan_clauses, function(index, clause){
                    // Exclude current updated payment plan from existing record to reflect updated changes
                    if(clause.payment_plan_id != self.paymentPlanParams.id){
                        existing_clauses.push({'payment_plan_id': clause.payment_plan_id, 'payment_plan_clause_id': clause.payment_plan_clause_id});
                    }
                });
            }
        
            // Now add existing clauses to updated record
            if(existing_clauses && existing_clauses.length > 0){
                $.each(existing_clauses, function(index, clause){
                    payment_plans_with_clauses += '{"payment_plan_id":'+ clause.payment_plan_id +', "payment_plan_clause_id":'+ clause.payment_plan_clause_id +'},';
                });
            }
        }
        catch(ex){
            console.log(ex);
        }

        self._updatePaymentPlan(payment_plans_with_clauses);
    }

    _updatePaymentPlan(payment_plans_with_clauses){
        const self = this;

        let url = 'sec/developer/interest-rates/'+ self.interestRateParams.id +'/payment-plans' ;
        var params = {
            'payment_plans_with_clauses': "["+ payment_plans_with_clauses.substring(0, payment_plans_with_clauses.lastIndexOf(',')) +"]"
        };

        let responseHandler = function(response){
            loading(false);
            self.hideModals();

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                if (response && response.code == 403) {
                    self.SSAlertService.danger('Forbidden!', 'The selected payment plan clause has already and active interest rate.');
                }
                return;
            }

            self.SSAlertService.success('Success!', 'The payment clause(s) has been updated successfully');
            self.getInterestRates();
            self.interestRateUpdateMode = false;
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(responseHandler);
    }

    updatePaymentPlanSelection(){
        const self = this;

        let _payment_plan = self.paymentPlans.find(x => x.id == self.paymentPlanParams.id);

        if(_payment_plan){
            self.paymentPlanParams.clauses = _payment_plan.payment_plan_clauses;
        }
        self.checkAllPaymentPlanClausesSelected();
    }

    selectAllPaymentPlanClauses(){
        const self = this;
        self.selected_all_payment_plan_clauses = !self.selected_all_payment_plan_clauses;
        self.paymentPlanParams.clauses.forEach(function (clause) {
            self.selected_payment_plan_clauses[clause.id] = self.selected_all_payment_plan_clauses;
        });
    }

    checkAllPaymentPlanClausesSelected(){
        const self = this;
        let check = true;
        self.selected_all_payment_plan_clauses = false;
        self.paymentPlanParams.clauses.forEach(function (clause) {
            if(!self.selected_payment_plan_clauses[clause.id]) {
                self.selected_all_payment_plan_clauses = false;
                check = false;
            }
        });
        if(check){
            self.selected_all_payment_plan_clauses = true;
        }
    }

    calculateInterestRate(){
        const self = this;

        let base_rate = self.interestRateParams.base_rate;
        let client_rate = self.interestRateParams.client_rate;

        if(!base_rate || !client_rate){
            return 0;
        }

        self.interestRateParams.cumulativeInterestRate = parseFloat(base_rate) + parseFloat(client_rate);
        self.interestRateParams.interest_rate = self.interestRateParams.cumulativeInterestRate;
    }

    deleteInterestRate(interest){
        const self = this;

        if(!interest){
            return;
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you would like to delete this interest rate?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function() {
                self._deleteInterestRate(interest);
            }
        );
    }

    _deleteInterestRate(interest){
        const self = this;

        let url = 'sec/developer/interest-rates/'+ interest.id +'/delete';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'The interest rate has been deleted successfully');
            self.getInterestRates();
        });
    }

    removePaymentPlan(payment_plan){
        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you would like to remove this payment plan?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function() {

                var payment_plans_with_clauses = '';
                try{
                    if(self.interestRateParams.payment_plan_clauses){
                        $.each(self.interestRateParams.payment_plan_clauses, function(index, clause){
                            // Exclude current payment_plan from existing record
                            if(clause.payment_plan_id != payment_plan.id){
                                payment_plans_with_clauses += '{"payment_plan_id":'+ clause.payment_plan_id +', "payment_plan_clause_id":'+ clause.payment_plan_clause_id +'},';
                            }
                        });
                    }
                }
                catch(ex){
                    console.log(ex);
                }

                self._updatePaymentPlan(payment_plans_with_clauses);
            }
        );
    }

    isValidInterestRateInput() {
        const self = this;

        let isValid = true;

        self.interestRateErrors = {};
        
        if (!self.interestRateParams.base_rate || self.interestRateParams.base_rate === 0) {
            self.interestRateErrors.base_rate = 'Base rate is required';
            isValid = false;
        }
        if (!self.interestRateParams.client_rate) {
            self.interestRateErrors.client_rate = 'Client rate is required';
            isValid = false;
        }
        // Grace period can be zero
        // if (!self.interestRateParams.grace_period) {
        //     self.interestRateErrors.grace_period = 'Grace period field is required';
        //     isValid = false;
        // }
        if (!self.interestRateParams.working_days) {
            self.interestRateErrors.working_days = 'Please select working day(s)';
            isValid = false;
        }

        if(!self.interestRateParams.availability_start_date){
            self.interestRateErrors.availability_start_date = 'Please select start date';
            isValid = false;
        }

        if(!self.interestRateParams.availability_end_date){
            self.interestRateErrors.availability_end_date = 'Please select end date';
            isValid = false;
        }

        return isValid;
    }

        preparePaymentPlanTypes(){
        const self = this;

        self.PAYMENT_PLAN_TYPES = [
            {id: self.PAYMENT_PLAN_TYPE_NPS, name: 'NPS'},
            {id: self.PAYMENT_PLAN_TYPE_DPS, name: 'DPS'},
            {id: self.PAYMENT_PLAN_TYPE_PVT, name: 'PVT'},
        ];
    }

    getPlanTypeName(type){
        const self = this;

        let name = '--';

        if(!type){
            return name;
        }

        return self.PAYMENT_PLAN_TYPES.find(x => x.id == type).name;
    }

    prepareWeakDays(){
        const self = this;

        self.WEEK_DAYS = [
            {'id': 1, 'name': 'Monday', 'short_name': 'Mon'},
            {'id': 2, 'name': 'Tuesday', 'short_name': 'Tue'},
            {'id': 3, 'name': 'Wednesday', 'short_name': 'Wed'},
            {'id': 4, 'name': 'Thursday', 'short_name': 'Thu'},
            {'id': 5, 'name': 'Friday', 'short_name': 'Fri'},
            {'id': 6, 'name': 'Saturday', 'short_name': 'Sat'},
            {'id': 7, 'name': 'Sunday', 'short_name': 'Sun'},
        ];
    }

    getWeekDays(days_ids){
        const self = this;


        if(!days_ids){
            return '--';
        }

        var ids = days_ids.split(',');
        var days = '';

        try{
            $.each(ids, function(index, id){
                let day = self.WEEK_DAYS.find(x => x.id == id);
                if(day){
                    days += day.short_name + ', ';
                }
            });

            if(days){
                // Remove last ',' at the end of string 
                days = days.substring(0, days.lastIndexOf(','));
            }
        }
        catch(ex){
            console.log(ex);
        }

        return days.trim();
    }

    getWeekDayName(id){
        const self = this;

        if(!id){
            return '--';
        }

        var day_name = '--';

        try{
            let day = self.WEEK_DAYS.find(x => x.id == id);
            if(day){
                day_name = day.short_name;
            }
        }
        catch(ex){
            console.log(ex);
        }

        return day_name;
    }

    setPageOptions(){
        const self = this;

        self.PAGE_OPTIONS = [
            {
                id: 5,
                name: '5 Rows'
            },
            {
                id: 10,
                name: '10 Rows'
            },
            {
                id: 20,
                name: '20 Rows'
            },
            {
                id: 30,
                name: '30 Rows'
            },
            {
                id: 40,
                name: '40 Rows'
            },
            {
                id: 50,
                name: '50 Rows'
            },
            {
                id: 100,
                name: '100 Rows'
            },
            {
                id: 200,
                name: '200 Rows'
            },
            {
                id: 400,
                name: '400 Rows'
            }
        ];
    }

    setTotalPagesOptions(TOTAL_PAGES){
        const self = this;

        self.TOTAL_PAGES_OPTIONS = [];

        for(var index = 0; index < TOTAL_PAGES; index++){
            self.TOTAL_PAGES_OPTIONS.push({id: index + 1, name: 'PAGE ' + (index + 1).toString() });
        }
    }

    hideModals(){
        const self = this;

        if ($('#addPaymentPlanModal').is(':visible')) $('#addPaymentPlanModal').modal('hide');
    }

    editInterestRateFunction(){
        const self = this;
        self.editInterestRate = true;
    }

    getStatus(interest){
        const self = this;
        if(interest.availability_end_date == '--' || !interest.availability_end_date || interest.availability_start_date == '--' || !interest.availability_start_date)
            return false;
        let current_date = moment().utc().format('YYYY-MM-DD HH:mm');
        let start_date = self.SSUtilService.formatLocalToUtc(interest.availability_start_date);
        let end_date = self.SSUtilService.formatLocalToUtc(interest.availability_end_date);
        if(interest.is_enabled && (start_date <= current_date) && (end_date >= current_date)){
            return true;
        }
    }

}

DeveloperInterestRatesController.$inject = ['$scope', '$window', 'SSHttpService', 'SSConfigService', 'SSAlertService', 'SSUtilService', 'OTPService', 'SSAppService', 'SSUserService','SSConfirmationService', 'SSDateService', 'SSAnalyticsService'];
app.controller('DeveloperInterestRatesController', DeveloperInterestRatesController);

app.directive("datetimepicker", function () {

    function link(scope, element, attrs) {
        // CALL THE "datepicker()" METHOD USING THE "element" OBJECT.
        element.datetimepicker({
            dateFormat: "dd/mm/yy",
            changeMonth: true,
            changeYear: true,
            showTimePicker: false,
            showSecond:false,
            showMillisec:false,
            showMicrosec:false,
            showTimezone:false
        });
    }

    return {
        require: 'ngModel',
        link: link
    };
});
